var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState, useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import ApiContext from '../contexts/apiContext';
import { getMessages } from '../api';
import messageFiltersToSearchParams from '../helpers/messageFiltersToSearchParams';
import searchParamsToMessageFilter from '../helpers/searchParamsToMessageFilters';
import AdminMenu from './AdminMenu';
import MessageList from './MessageList';
import ErrorDialog from './ErrorDialog';
var Admin = function () {
    var apiBaseUrl = useContext(ApiContext).apiBaseUrl;
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var _b = useState(searchParamsToMessageFilter(searchParams)), messageFilters = _b[0], setMessageFilters = _b[1];
    var _c = useState([]), messages = _c[0], setMessages = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(false), reachedEnd = _e[0], setReachedEnd = _e[1];
    var _f = useState(), errorMessage = _f[0], setErrorMessage = _f[1];
    var infiniteScrollTarget = useRef(null);
    useEffect(function () {
        setSearchParams(messageFiltersToSearchParams(messageFilters));
        setMessages([]);
        fetchNextMessages([]).catch(function (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            setErrorMessage("There's been an error fetching messages, please check your connection and try again");
        });
    }, [messageFilters]);
    var fetchNextMessages = function (previousMessages) { return __awaiter(void 0, void 0, void 0, function () {
        var nextMessages;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    setReachedEnd(false);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, getMessages(apiBaseUrl, __assign(__assign({}, messageFilters), { cursor: (_a = previousMessages[previousMessages.length - 1]) === null || _a === void 0 ? void 0 : _a.cursor }))];
                case 2:
                    nextMessages = _b.sent();
                    setReachedEnd(nextMessages.length === 0);
                    setMessages(__spreadArray(__spreadArray([], previousMessages, true), nextMessages, true));
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting && messages.length > 0 && !reachedEnd) {
                fetchNextMessages(messages).catch(function (err) {
                    // eslint-disable-next-line no-console
                    console.error(err);
                    setErrorMessage("There's been an error fetching messages, please check your connection and try again");
                });
            }
        }, { rootMargin: '100px', threshold: 1 });
        if (infiniteScrollTarget.current) {
            observer.observe(infiniteScrollTarget.current);
        }
        return function () {
            if (infiniteScrollTarget.current) {
                observer.unobserve(infiniteScrollTarget.current);
            }
        };
    }, [infiniteScrollTarget, fetchNextMessages, messages, reachedEnd]);
    var handleErrorDialogClose = function () { return setErrorMessage(undefined); };
    return (_jsxs(_Fragment, { children: [_jsx(ErrorDialog, { message: errorMessage, onClose: handleErrorDialogClose }), _jsx(AdminMenu, { messageFilters: messageFilters, setMessageFilters: setMessageFilters }), !loading && messages.length === 0 && (_jsx(Alert, { severity: "info", sx: { justifyContent: 'center' }, children: "No messages found" })), _jsx(MessageList, { messages: messages, loading: loading, goToBottom: false }), _jsx(Box, { ref: infiniteScrollTarget })] }));
};
export default Admin;
